import cookies from 'js-cookie';
import Department from '../_blessed/store/entities/departments/model';

export const DEPARTMENT_KEY = 'da-department';
export const IMPERSONATE_TOKEN_KEY = 'impersonate-token';

export const setAuth0Token = (token: string) => {
  cookies.set('auth0_token', token);
};
export const getAuth0Token = () => cookies.get('auth0_token');

export function isValidHUBDashobardUser(department: Department | null) {
  if (!department) {
    return false;
  }

  return department.type === 'admin';
}

export function getAuthToken() {
  return getAuth0Token() ?? null;
}

export const getDepartmentUuidCookie = () => cookies.get('da-department') ?? null;

export const setDepartment = (department: Department | null) => {
  if (department && isValidHUBDashobardUser(department)) {
    cookies.set(DEPARTMENT_KEY, department.uuid);
  }
};

export const clearAuthTokens = () => {
  cookies.remove(DEPARTMENT_KEY);
};

export const clearCookies = () => {
  Object.keys(cookies.get()).forEach((cookieName) => {
    cookies.remove(cookieName);
  });
};
